// eslint-disable-next-line max-len
var USER_INTERFACE_ARROW_04_LEFT_THICK = 'm25.38,31.17c-.92,1.03-2.5,1.11-3.53.19l-15.04-13.5c-.53-.48-.83-1.15-.83-1.86s.3-1.38.83-1.86L21.85.64c1.03-.92,2.61-.84,3.53.19s.84,2.61-.19,3.53l-12.97,11.64,12.97,11.64c1.03.92,1.11,2.5.19,3.53Z';

export { USER_INTERFACE_ARROW_04_LEFT_THICK };
//# sourceMappingURL=USER_INTERFACE_ARROW_04_LEFT_THICK.js.map
